window.Popper = require('@popperjs/core').default;

require('bootstrap')